module.exports = __webpack_public_path__ + "static/img/sq.909043f2.png";